const content = [
    {
        "text": "Faktura",
        "style": {
            fontSize: 18,
            bold: true,
            color: '#666666',
            alignment: 'center',
        },
        "margin": [
            0,
            0,
            0,
            10
        ]
    },
    {
        "text": "Nr. {{title}}",
        "style": {
            alignment: 'center',
            italics: true,
            fontSize: 10,
        },
        "margin": [
            0,
            5,
            0,
            50
        ]
    },
    {
        layout: 'noBorders',
        "table": {
            "widths": ['*', 'auto'],
            "body": [
                [
                    {
                        "text": [
                            {
                                "text": "Data wystawienia:",
                                "style": {
                                    alignment: 'right',
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "Data sprzedaży:",
                                "style": {
                                    alignment: 'right',
                                    fontSize: 10,
                                },
                            }
                        ],
                        "margin": [
                            0,
                            5,
                            40,
                            10
                        ],
                    },
                    {
                        "text": [
                            {
                                "text": [
                                    {
                                        "text": "{{formattedDate}}",
                                        "style": {
                                            alignment: 'right',
                                            bold: true,
                                            fontSize: 10,
                                        },
                                    },
                                    "\n"
                                ],
                            },
                            {
                                "text": "{{formattedDate}}",
                                "style": {
                                    alignment: 'right',
                                    bold: true,
                                    fontSize: 10,
                                },
                            },
                        ],
                        "margin": [
                            0,
                            5,
                            0,
                            10,
                        ],
                        "style": [
                            "html-p",
                            "html-td",
                            "c35",
                            "c52",
                            "html-tr"
                        ],
                    }
                ],
            ]
        },
        "marginBottom": 0
    },
    {canvas: [{type: 'line', x1: 0, y1: 5, x2: 595 - 2 * 40, y2: 5, lineWidth: 0.2}]},
    {
        layout: 'noBorders',
        "table": {
            "widths": ['*', '*'],
            "body": [
                [
                    {
                        "text": [
                            {
                                "text": "Sprzedawca:",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "{{seller.name}}",
                                "style": {
                                    fontSize: 10,
                                    bold: true,
                                },
                            },
                            "\n",
                            {
                                "text": "{{seller.street}}",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "{{seller.postalCode}} {{seller.locality}}",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "{{sellerNipLine}}",
                                "style": {
                                    fontSize: 10,
                                },
                            }
                        ],
                    },
                    {
                        "text": [
                            {
                                "text": [
                                    {
                                        "text": "Nabywca:",
                                        "style": {
                                            fontSize: 10,
                                        },
                                    },
                                    "\n",
                                    {
                                        "text": [
                                            {
                                                "text": "{{buyer.name}}",
                                                "style": {
                                                    fontSize: 10,
                                                    bold: true,
                                                },
                                            },
                                            "\n"
                                        ],
                                    },
                                    {
                                        "text": "{{buyer.street}}",
                                        "style": {
                                            fontSize: 10,
                                        },
                                    }
                                ],
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "{{buyer.postalCode}} {{buyer.locality}}",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "{{buyerNipLine}}",
                                "style": {
                                    fontSize: 10,
                                },
                            }
                        ],
                    }
                ]
            ]
        },
        "marginTop": 30,
        "marginBottom": 25
    },
    {
        "layout": {
            hLineWidth: function (i, node) {
                return 0.2;
            },
            vLineWidth: function (i, node) {
                return 0.2;
            },
        },
        "table": {
            "body": [
                [
                    {
                        "text": "Lp",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Nazwa towaru lub usługi",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Jm",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Ilość",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Cena netto",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Stawka VAT",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Wartość netto",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Wartość VAT",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Wartość brutto",
                        "style": {
                            fontSize: 10,
                        },
                    }
                ],
                [
                    {
                        "text": "1",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{item}}",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "Szt.",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "1",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{netPrice}}",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{vat}}%",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{netPrice}}",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{vatPrice}}",
                        "style": {
                            fontSize: 10,
                        },
                    },
                    {
                        "text": "{{grossPrice}}",
                        "style": {
                            fontSize: 10,
                        },
                    }
                ]
            ]
        },
        "marginBottom": 30
    },
    {
        "layout": "noBorders",
        "table": {
            "widths": ['*', '*', '*', '*'],
            "body": [
                [
                    {
                        "text": [
                            {
                                "text": "Forma zapłaty:",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "Termin zapłaty:",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                        ],
                        margin: [0, 0, 20, 0],
                    },
                    {
                        "text": [
                            {
                                "text": "{{paymentMethod}}",
                                "style": {
                                    fontSize: 10,
                                    bold: true,
                                },
                            },
                            "\n",
                            {
                                "text": "{{formattedDate}}",
                                "style": {
                                    fontSize: 10,
                                    bold: true,
                                },
                            },
                        ],
                    },
                    {
                        "text": [
                            {
                                "text": "Razem:",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            "\n",
                            {
                                "text": "Słownie:",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                        ],
                        margin: [0, 0, 20, 0],
                    },
                    {
                        "text": [
                            {
                                "text": [
                                    {
                                        "text": "{{grossPrice}} PLN",
                                        "style": {
                                            fontSize: 10,
                                            bold: true,
                                        },
                                    },
                                    "\n"
                                ],
                            },
                            {
                                "text": "{{spokenPrice}} ",
                                "style": {
                                    fontSize: 10,
                                },
                            },
                            {
                                "text": "PLN {{groszPrice}}/100",
                                "style": {
                                    fontSize: 10,
                                },
                            }
                        ],
                    }
                ]
            ]
        },
        "style": [
            "html-table",
            "c21"
        ],
        "marginBottom": 60
    },
    /* {
        "layout": "noBorders",
        "table": {
            "widths": [30, '*', 20, '*', 30],
            "body": [
                [
                    {
                        "text": " ",
                    },
                    [
                        {
                            "text": "Przemysław Kędzierski",
                            "style": {
                                fontSize: 10,
                                alignment: 'center',
                            },
                        },
                        {
                            canvas: [{type: 'line', x1: 0, y1: 5, x2: 180, y2: 5, lineWidth: 0.2}],
                            style: {alignment: 'center'}
                        },
                    ],
                    {
                        "text": " ",
                    },
                    [
                        {
                            "text": "Agnieszka Klientka-Intercars",
                            "style": {
                                fontSize: 10,
                                alignment: 'center',
                            },
                        },
                        {
                            canvas: [{type: 'line', x1: 0, y1: 5, x2: 180, y2: 5, lineWidth: 0.2}],
                            style: {alignment: 'center'}
                        },
                    ],
                    {
                        "text": " ",
                    }
                ],
                [
                    {
                        "text": " ",
                    },
                    {
                        "text": "Osoba upoważniona do wystawienia",
                        "style": {
                            fontSize: 7,
                            alignment: 'center',
                        },
                    },
                    {
                        "text": " ",
                    },
                    {
                        "text": "Osoba upoważniona do odbioru",
                        "style": {
                            fontSize: 7,
                            alignment: 'center',
                        },
                    },
                    {
                        text: " ",
                    }
                ]
            ]
        },
        "marginBottom": 5
    }, */
];

const footer = {
    "layout": "noBorders",
    "table": {
        "widths": ['*', 'auto', '*'],
        "body": [
            [
                {
                    "text": "Faktura wygenerowana przez",
                    "style": {
                        fontSize: 8,
                        color: '#bbb',
                        alignment: 'right',
                    },
                    margin: [0, 3],
                },
                {
                    "image": "data:image/png;base64, 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",
                    "width": 100.5,
                    "height": 15,
                },
                {
                    "text": "www.getthebox.eu",
                    "style": {
                        fontSize: 8,
                        color: '#bbb',
                    },
                    margin: [0, 3],
                }
            ]
        ]
    },
    "marginBottom": 5
};

export { content, footer };
